import Joyride, { type CallBackProps } from "react-joyride";
import {
  TOUR_DEFAULT_PROPS,
  TOUR_LOCALE,
  TOUR_STYLES,
} from "@/shared/tour/config";
import { userFormTourSteps } from "./formTourSteps";

type UserFormTourProps = {
  run: boolean;
  onCallback: (data: {
    status?: string;
    type?: string;
    index?: number;
    action?: string;
  }) => void;
};

export function UserFormTour({ run, onCallback }: UserFormTourProps) {
  const handleCallback = (data: CallBackProps) => {
    const { status, type, index, action } = data;
    onCallback({ status, type, index, action });
  };

  return (
    <Joyride
      steps={userFormTourSteps}
      run={run}
      callback={handleCallback}
      locale={TOUR_LOCALE}
      styles={TOUR_STYLES}
      {...TOUR_DEFAULT_PROPS}
    />
  );
}

export { useUserFormTour } from "./useUserFormTour";
